import React from "react";
import { string } from "prop-types";

import { unitShape } from "../../common/unit.js";

import DetailPage from "../DetailPage/DetailPage.jsx";
import VirtualTourButton from "../VirtualTourButton/VirtualTourButton.jsx";
import MapViewSimple from "../MapView/MapViewSimple.jsx";
import { VirtualTourIcon } from "../../common/icons.jsx";
import * as R from "ramda";

const propTypes = {
  applyNowUrl: string,
  listingUrl: string.isRequired,
  unit: unitShape,
};

// TODO get this from context
const LINK_STYLE = "coh-style-link-button---filled";

const UnitDetailPage = props => {
  const { applyNowUrl, listingUrl, unit } = props;

  const {
    area,
    availableDate,
    displayDate,
    bathrooms,
    bedrooms,
    floorPlan,
    image,
    matterportId,
    selfguidedTour,
    price,
    unitNumber,
    sightmapEmbed,
  } = unit;

  const date = new Date(availableDate);
  const now = new Date();
  const moveInText = date < now ? "Available Now" : `Move-in ${displayDate}`;

  return (
    <DetailPage listingUrl={listingUrl}>
      <div className="unit-detail">
        <div className="unit-detail__info">
          <div className="unit-detail__title unit-detail__title coh-style-heading-3-alt-size">
            Apartment {unitNumber}
          </div>

          <div className="unit-detail__price coh-style-heading-4-size">
            Price: {price}
          </div>
          <div className="unit-detail__floor-plan coh-style-heading-4-size">
            Plan: {floorPlan}
          </div>

          <div className="unit-detail__features coh-style-heading-4-size coh-style-color-1">
            Features Included
          </div>
          <ul className="coh-style-heading-5-size unit-detail__list">
            <li>{area} Sq. Ft.</li>
            <li>{bedrooms}</li>
            <li>{bathrooms}</li>
          </ul>
          <ul className="coh-style-heading-5-size">
            <li>{moveInText}</li>
          </ul>

          <div className="unit-detail__buttons">
            <div className="unit-detail__buttons-inner">
              <VirtualTourButton
                className={`${LINK_STYLE} icon-button`}
                matterportId={matterportId}
                aria-label={`Apartment ${unitNumber} virtual tour`}
              >
                <VirtualTourIcon /> Virtual Tour
              </VirtualTourButton>
              {selfguidedTour && (
                <a
                  href={selfguidedTour}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${LINK_STYLE} icon-button`}
                  aria-label={`Apartment ${unitNumber} apply now`}
                >
                  Book a Tour
                </a>
              )}
              {applyNowUrl && (
                <a
                  href={`${applyNowUrl}?MoveInDate=${availableDate}&UnitId=${R.pathOr(
                    0,
                    ["realPageId"],
                    unit,
                  )}`}
                  aria-label={`Apartment ${unitNumber} apply now`}
                  className={`${LINK_STYLE} icon-button`}
                >
                  Apply Now
                </a>
              )}
            </div>
          </div>

          <div className="unit-detail__fine-print">
            * Floor plan drawings and renderings are an artist’s depiction and
            may not be to scale. All images, renderings, specifications,
            amenities and details are subject to change without notice. Room
            dimensions are approximate and may vary depending on home selected.
          </div>
        </div>
        <div className="unit-detail__image">
          <img src={image} alt={`Floorplan ${floorPlan}`} />
        </div>
      </div>
      {!R.isNil(sightmapEmbed) && <MapViewSimple unit={unitNumber} />}
    </DetailPage>
  );
};

UnitDetailPage.propTypes = propTypes;
export default UnitDetailPage;
